import { initialState, TCacheMethods, TCacheStore } from "./cache.state";
import { cacheReducer } from "./cache.reducer";

// ✅ Reusable store methods
export const createCacheActions = (
  set: any,
  // get: () => TCacheStore
): Pick<TCacheStore, TCacheMethods> => ({
    dispatch: (action) => set((state: TCacheStore) => cacheReducer(state, action)),

    reset: () => {
        set(initialState);
    }
});
